/**
 * @fileoverview GET handler for the "/engagement/:app_group_id/kakao_sender_keys" endpoint
 */
import fetch from "@lib/fetch";

import { reactQueryFetcherAdapter } from "../reactQueryFetcherAdapters";
import { engagementAppGroupIdKakaoSenderKeys } from "./constants";
import type { EngagementAppGroupIdKakaoSenderKeysResult } from "./types";
import { isEngagementAppGroupIdKakaoSenderKeysResult } from "./validators";

export const getEngagementAppGroupIdKakaoSenderKeys = reactQueryFetcherAdapter(
  engagementAppGroupIdKakaoSenderKeys,
  (signal: AbortSignal, appGroupId: string): Promise<EngagementAppGroupIdKakaoSenderKeysResult> => {
    return fetch(`/engagement/${appGroupId}/kakao_sender_keys`, "GET", {}, { signal });
  },
  isEngagementAppGroupIdKakaoSenderKeysResult
);
